// extracted by mini-css-extract-plugin
module.exports = {"container":"GameOver_container__2nVb_","heading":"GameOver_heading__anogU","playerName":"GameOver_playerName__2yH2j","playAgain":"GameOver_playAgain__5y9Fb"};